import React from 'react'

export function useIsSSR() {
  return React.useSyncExternalStore(
    noop,
    () => false,
    () => true
  )
}
const noop = () => () => undefined
